

export default {
    alarm:require("./alarm.png"),
    device:require("./device.png"),
    event:require("./event.png"),
    order:require("./order.png"),
    organs:require("./organs.png"),
    unit:require("./unit.png"),
    user:require("./user.png"),
    screen:require("./screen.png"),
    statistics:require("./statistics.png"),
    anquandaka:require("./anquandaka.png"),
    xianchangkancha:require("./xianchangkancha.png"),
    yinhuanpaicha:require("./yinhuanpaicha.png"),
    SafetyRecord: require("./SafetyRecord.png"),
    SmartScene: require("./SmartScene.png"),
    SysLog: require("./SysLog.png"),
    WorkRecordManage: require("./WorkRecordManage.png"),
    PushStrategy: require("./PushStrategy.png"),
    Inspect: require("./Inspect.png"),
    Document: require("./Document.png"),
}